<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <span>Значение</span>
        <v-text-field
          outlined
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.value"
          @input="mixChangeListItemHandler($event, 'value')"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <span>Метка</span>
        <v-text-field
          outlined
          :disabled="isLoading"
          :loading="isLoading"
          :value="listItem.data.label"
          @input="mixChangeListItemHandler($event, 'label')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import dynamicListItemMix from '@/mixins/dynamic-list/dynamicListItem.mix.js'

export default {
  name: 'DictionaryOption',
  mixins: [dynamicListItemMix]
}
</script>
